<template>
  <Card
    tag="form"
    variant="widget"
    class="model-template-mutate-residential-settings"
    @submit.prevent="$emit('submit')"
  >
    <template #header>
      <div class="card-v2__title">{{ $tc('unitSettings', 1) }}</div>
      <DropdownComponent :close-on-click="true">
        <ButtonComponent :label="$tc('adaptation', 2)" icon="fa-pro-light:sliders" />
        <template #dropdown>
          <ButtonComponent
            v-for="item in ['list', 'order']"
            :label="$t(`unitsAdaptationsTrigger${Capitalize(item)}`)"
            @click="settingsVariant = item"
          >
          </ButtonComponent>
        </template>
      </DropdownComponent>
    </template>

    <template #default>
      <SettingsComponent
        :useValue="true"
        :variant.sync="settingsVariant"
        :value="get(['metadata', 'siteSettings', 'residentialProperties'])"
        @input="$ev => set(['metadata', 'siteSettings', 'residentialProperties'], $ev)"
      ></SettingsComponent>

      <div class="model-template-mutate-residential-settings__input">
        <FieldRenderer v-for="item in fields.default" :item="item" :value="value" />

        <CustomFields
          v-model="value.customFields"
          :schema="customFieldSchemas"
          :data="data"
          :placement="placement"
          @remove="$ev => removeCustomField($ev)"
          :validator="validator"
          validator-prefix="customFields"
          :disabledFields="$path('metadata.disabledFields.modelTemplate', item)"
        >
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer :item="item" :value="value" />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'
import { assocPath } from 'ramda'
import Card from '@/components/Card-v2'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/ModelTemplate/StepsFields/FieldRenderer.vue'
import { InputComponent } from 'vue-elder-input'
import SettingsComponent from '@/components/Residential/Settings/index.js'
import { DropdownComponent } from 'vue-elder-dropdown'
import { Capitalize } from '@/utils'
import { setByPath } from '@/utils'

const meta = {
  order: 7,
  id: 'unitSettings',
  label: i18n.tc('unitSettings', 1),
  skip(item) {
    return !(item.id && item.ofType === 'Project')
  },
}

export { meta }
export default {
  props: {
    data: Object,
    value: {
      type: Object,
      default: () => ({}),
    },
    labels: Object,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      placement: ['unitSettings', 'modelTemplate:unitSettings'],
      settingsVariant: '',
    }
  },
  computed: {
    ...mapState('ModelTemplate', ['item']),
  },
  methods: {
    Capitalize,
    removeCustomField(item) {
      this.value.customFields = assocPath(item.key.split('.'), null, this.value.customFields)
      this.value.customFieldsConfig = this.value.customFieldsConfig.filter(c => c.source !== item.source)
    },
    get(key) {
      return this.$path(key, this.value)
    },
    set(key, value) {
      setByPath(key, value, this.value)
    },
  },
  components: {
    Card,
    CustomFields,
    FieldRenderer,
    InputComponent,
    SettingsComponent,
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.model-template-mutate-residential-settings {
  max-width: 900px;
  margin: auto;

  $cols: 2;

  .elder-loader {
    flex-grow: 0;
  }

  &__header {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    align-items: start;
    justify-content: space-between;
    padding: var(--card-spacing);
    padding-bottom: 0;

    p {
      margin: 0;
    }
  }

  & > .card-v2 {
    &__header {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  &__input {
    display: grid;
    grid-template-columns: repeat($cols, 1fr);
    grid-gap: $form-gap;

    padding: var(--card-spacing);

    // [data-field='name'],
    // [data-field='themes'] {
    //   grid-column-end: span 2;
    // }
  }

  .custom-fields {
    grid-column-end: span $cols;
  }
}
</style>
